import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CpExamination } from '@se/models';
import { Guid, ModalDialogNotificationService, NotificationType } from '@se/se.ui.html5';
import { flatten, uniq, uniqBy } from 'lodash-es';
import { firstValueFrom, Observable } from 'rxjs';

import { CpHttpService } from '../services/cp-http.service';

@Injectable({
    providedIn: 'root',
})
export class CpRouterDatabuilderService {
    constructor(
        private cpHttpService: CpHttpService,
        public modalDialogNotificationService: ModalDialogNotificationService,
        private translate: TranslateService
    ) {}

    async buildCpArguments(
        selectedItems: CpExamination[],
        getReportExaminations: (idReport: string) => Observable<CpExamination[]>,
        errorMessage = 'WarningOpenExamsTypes'
    ) {
        const examinations = [];
        for (const examination of selectedItems) {
            const idCustomPage = examination.idCustomPage === Guid.EMPTY ? null : examination.idCustomPage;
            // Nel caso di idReport valorizzato e idCustomPage non valorizzata, ricalcolo l'idCustomPageRoot
            const idCustomPageRoots =
                examination.idReport && !idCustomPage
                    ? (await firstValueFrom(getReportExaminations(examination.idReport))).map(
                          (ex) => ex.idCustomPageRoot
                      )
                    : [examination.idCustomPageRoot];

            examinations.push({
                id: examination.id,
                idCustomPage,
                idCustomPageRoots,
                idModelTypeRoots: examination.idModelTypeRoots,
                idReport: examination.idReport,
            });
        }

        const idExaminations = examinations.map((s) => s.id);
        // Nel caso di più prestazioni, ricerca la customPage adatta a refertarle tutte.
        const uniqueIdCustomPageRoots = uniq(flatten(uniqBy(examinations, 'id').map((ex) => ex.idCustomPageRoots)));
        const idCustomPageRoot =
            uniqueIdCustomPageRoots.length === 1
                ? uniqueIdCustomPageRoots[0]
                : (await firstValueFrom(
                      this.cpHttpService.resolveIdCustomPageRoot(uniqueIdCustomPageRoots, idExaminations)
                  )) || '';

        if (!idCustomPageRoot) {
            await firstValueFrom(
                this.modalDialogNotificationService.notify({
                    buttonYes: false,
                    buttonNo: false,
                    buttonCancel: false,
                    buttonOk: true,
                    title: this.translate.instant('Warning'),
                    message: this.translate.instant(errorMessage),
                    type: NotificationType.warning,
                })
            );
            return null;
        } else {
            return { examinations, idCustomPageRoot };
        }
    }
}
